import { Link } from "react-router-dom";

export default function HomeCta() {
  return (
    <section className="mx-auto w-full px-4 pb-16 md:px-8 md:pb-20">
      <div className="relative overflow-hidden rounded-lg border border-primary-200 bg-primary-50 px-6 py-12 md:px-12 md:py-16">
        <div className="relative z-10 flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
              <i className="ri-megaphone-line"></i>
              线索征集进行中
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              有想说的故事？我们愿意认真听完
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
              无论是消费踩坑、职场经历，还是城市里的小小见闻，都可以通过投稿入口告诉我们。
              支持匿名提交，编辑会协助你理清时间线。
            </p>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line text-base"></i>
              前往投稿
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3 text-sm font-semibold text-primary-800 transition-colors hover:bg-primary-100"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}